/* eslint-disable indent, quotes, react/prop-types */
/* eslint-env browser */

import React from "react";
import Meta from "../components/Meta";
import FooterMap from "../components/FooterMap";
import graphql from "../util/graphql";


function canalWalk(page) {
  return page.route === "/explore-downtown/riverfront-canal-walk/" ? <FooterMap /> : null;
}

// Interior page default template
class VistityFullPage extends React.PureComponent {
  componentDidMount() {
    const links = [].slice.call(document.querySelectorAll(".text-block__container a"));
    links.map(l => l.setAttribute("target", "_blank"));
  }

  render() {
    const { data } = this.props;
    const page = data.mortyPage;


    return (
      <div className="page">
        <Meta page={page} />
        <div className="pt2 pb3 pt3-l pb5-l flex items-center justify-center flex-column">
          <div className=" w-calc-64 relative clearfix">
            <iframe
              className="vistity-iframe"
              src="https://explore.vistity.com/tour/downtown-richmond"
              id="tour-iframe"
              style={{ height: '100vh', width: '100%' }}
            />
          </div>

          <div className="text-block__container w-100">
            <div className="text-block__body p mb0 grey2">
              {page.route !== '/live-downtown/virtual-tour/' && page.route !== '/work-downtown/virtual-tour/' ?
                <h3 className="text-block__subheadline p-emphasis h-3--l ttu dark">
                  If you don&apos;t see your business included in our downtown tour, please <a href="mailto:contactus@venturerichmond.com">email</a> us and we&apos;ll add it. This virtual tour is always being updated
                </h3>
                : null
              }


              {page.route === '/live-downtown/virtual-tour/' || page.route === '/work-downtown/virtual-tour/' ?
                <p className="text-block__body p mb0 grey2">
                The Downtown Richmond virtual tour offers a comprehensive overview of Downtown's economic development, featuring its eight neighborhoods, popular areas within each neighborhood, and residential and mixed-use ventures. As users navigate through the virtual landscape, they can delve into specific areas and available housing within each neighborhood. For locals and those looking to make the move to Richmond alike, it serves as a powerful tool to learn about all the opportunities and living space Downtown Richmond has to offer.
                </p>
               : null
              }

              {page.route === '/live-downtown/virtual-tour/' ?
                <p className="text-block__body p mb0 grey2 m-t-14">
                 Prospective residents and tenants can explore over 150 residential projects, gaining insight into the city's booming housing landscape and potential investment opportunities.
                </p>
               : null
              }

              {page.route === '/work-downtown/virtual-tour/' ?
                <p className="text-block__body p mb0 grey2 m-t-14">
                 Prospective investors and tenants can explore over 150 residential projects, gaining insight into the city's booming housing landscape and potential investment opportunities.
                </p>
               : null
              }

              {page.route === '/live-downtown/virtual-tour/' || page.route === '/work-downtown/virtual-tour/' ?
                <p className="text-block__body p mb0 grey2 m-t-14">
                As Downtown continues to evolve, Venture Richmond’s Downtown Virtual Tour, which is constantly updated with the newest projects, will remain the ultimate guide for those seeking to unlock the full potential of downtown’s dynamic landscape.
                </p>
                : null
              }

              {page.route === '/live-downtown/virtual-tour/' || page.route === '/work-downtown/virtual-tour/' ?
                <p className="text-block__body p mb0 grey2 m-t-14">
                If you don't see your business included in our downtown tour, please <a href="mailto:contactus@venturerichmond.com">email</a>  us and we'll add it.
                </p>
                : null
              }

            </div>


          </div>

        </div>
        {canalWalk(page)}
      </div>
    );
  }
}

export default VistityFullPage;

export const pageQuery = graphql`
  query VistityFullPage($id: String!) {
    mortyPage(id: { eq: $id }) {
      title
      subtitle
      metaTitle
      metaDescription
      metaKeywords
      bannerImageAltText
      bannerImageFocalPointX
      bannerImageFocalPointY
      bannerImage {
        url
      }
      abstract
      abstractPhotoAltText
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      abstractPhoto {
        url
      }
      route
      slug
      childrenMortyBlock {
        id
        blockType
        content
        headline
        subheadline
        buttonUrl
        buttonTitle
        format
        caption
        subcaption
        url
        attribution
        focalPointX
        focalPointY
        altText
        attributionAltText
        attributionPhoto {
          url
        }
        image {
          url
        }
        videoType
        videoMinutes
        embedCode
        attribution
        attributionAltText
        attributionPhoto {
          url
        }
      }
    }
  }
`;

export const previewQuery = `
  query VistityFullPage($id: String!) {
    mortyPage(id: { eq: $id }) {
      title
      subtitle
      metaTitle
      metaDescription
      metaKeywords
      bannerImageAltText
      bannerImageFocalPointX
      bannerImageFocalPointY
      bannerImage {
        url
      }
      abstract
      abstractPhotoAltText
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      abstractPhoto {
        url
      }
      route
      slug
      childrenMortyBlock {
        id
        blockType
        content
        headline
        subheadline
        buttonUrl
        buttonTitle
        format
        caption
        subcaption
        url
        attribution
        focalPointX
        focalPointY
        altText
        attributionAltText
        attributionPhoto {
          url
        }
        image {
          url
        }
        videoType
        videoMinutes
        embedCode
        attribution
        attributionAltText
        attributionPhoto {
          url
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/Vistity-FullPage.js